export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-page-delete-32dff877bd79eac441435b4785d8c2ac.svg";